orders-approvals-stamp(class="{required: opts.required} {enable: opts.enable} {done: opts.done} {cancelable: opts.cancelable}")
  .stamp-wrap
    .stamp-body
      .stamp.stamp-approval(if="{opts.enable && opts.required && !opts.done}" data-toggle="tooltip" data-placement="top" title="{locale().attentions.required}")
        span {opts.date}
        span {opts.name}
      .stamp.stamp-approval(if="{!opts.enable || !opts.required || opts.done}")
        span {opts.date}
        span {opts.name}
    .stamp-footer
      span {opts.label}
  .btn-wrap
    .btn-create.btn.btn-block.btn-primary.btn-sm(if="{opts.enable && !opts.done}" onClick="{this.onClickCreate}") { this.locale().btns.create }
    .btn-destroy.btn.btn-block.btn-info.btn-sm(if="{opts.enable && opts.done && opts.cancelable}" onClick="{this.onClickDestroy}") { this.locale().btns.destroy }
    .btn-require.btn.btn-block.btn-warning.btn-sm(if="{opts.requireable && !opts.enable && !opts.done}" onClick="{this.onClickRequire}") { this.locale().btns.require }
  style(scoped).
    :scope {
      display: block;
      position: relative;
    }
    .stamp-wrap {
      display: block;
      width: 80px;
      height: 100px;
      border: 1px solid #666666;
      position: relative;
      margin-bottom: 1px;
    }
    :scope.required .stamp-wrap:before {
      display: block;
      content: " ";
      width: 80px;
      height: 100px;
      position: absolute;
      left: -1px; top: -1px;
      border: 2px solid red;      
    }
    .stamp-body {
      width: 70px;
      height: 70px;
      margin: 8px 4px 2px 4px;
    }
    :scope .stamp-approval {
      display: none;
    }
    :scope.enable .stamp-approval,
    :scope.done   .stamp-approval {
      display: block;
    }
    .stamp-footer {
      font-size: 10px;
      text-align: center;
    }
    .stamp { font-size:9px; border-width:3px; border-style: double; border-radius:50%; width:70px; height:70px; position:relative; margin:auto; }
    .stamp span { display:inline-block; width:100%; text-align:center; }
    .stamp span:first-child::before { position:absolute; top:5px; left:0; right:0; margin:auto; width:80%; border-bottom:1px solid #FF0000; line-height:1; padding-bottom:3px; }
    .stamp span:first-child { line-height:56px; }
    .stamp span:last-child { position:absolute; top:38px; left:0; right:0; margin:auto; width:80%; border-top:1px solid #FF0000; padding-top:2px; line-height:1; }

    .stamp-approval span:first-child::before {
      content:"承認";
    }
    :scope.enable .stamp {
      color:#DDDDDD;
      border-color:#DDDDDD;
    }
    :scope.enable .stamp span:first-child::before {
      border-bottom-color: #DDDDDD;
    }
    :scope.enable .stamp span:last-child {
      border-top-color: #DDDDDD;
    }
    :scope.done .stamp {
      color: #FF0000;
      border-color: #FF0000;
    }
    :scope.done .stamp span:first-child::before {
      border-bottom-color: #FF0000;
    }
    :scope.done .stamp span:last-child {
      border-top-color: #FF0000;
    }
    .btn-wrap {
      padding: 1px;
    }
  script(type="typescript").
    this.mixin('orders.approvals.stamp');
